import React, { useEffect } from 'react';
import { MLAlertGroupComponent } from 'ml-components-common-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';

import messages from './MLCancellationContactUsPage.messages';

function MLCancellationContactUsPage() {
    const AlertService = MLNotificationBlockUtil();

    useEffect(() => {
        AlertService.addErrorAlert(messages.error, 'cancellationError');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="page-content-gpa">
            <MLAlertGroupComponent noWizard />
        </div>
    );
}

export default MLCancellationContactUsPage;